import { useUpdateFileReference } from './useUpdateFileReference';
import { getUpdateObjFromUpload } from '../data/getUpdateObjFromUpload';
import { UpdateFileRefPayload } from '../types/Chart/UpdateFileRefPayload';
import { FileUploadSuccess } from '../types/Files/FileUploadSuccess';
import React from 'react';

export const useHandleFileUploadSuccess = () => {
  const { mutate } = useUpdateFileReference();
  const updateFirestore = React.useCallback(
    (payload: FileUploadSuccess) => {
      const docToUpdate = payload.docToUpdate;
      const data = getUpdateObjFromUpload(payload.type, payload.url);
      const updateBody = {
        [docToUpdate]: {
          patientId: payload.patientId || ' ',
          docData: data,
        },
      } as UpdateFileRefPayload;
      mutate(updateBody);
    },
    [mutate],
  );
  return { updateFirestore };
};
